<template>
  <!--header-->
  <div class="header">
    <div class="theHeadWidth">
      <div class="header_top">
        <div class="header_logo">
          <router-link to="/">
            <img src="../assets/image/jiaozhuan_03.png" alt="" />
          </router-link>
        </div>

        <div class="header_search">
          <!-- <span class="theDropdownChoice"> 项目 </span> -->
          <input type="text" class="theSearchInput" placeholder="请输入想搜索的内容...">
          <input type="button" class="searchbutton" value="搜索" />
          <!--@click="atTheTopOfTheSearch(searchData.searchContent)" -->
        </div>

        <div class="header_right" v-if="!userName">
          <span class="loginAvatar">
            <img src="../assets/image/loginico.png" alt="" />
          </span>
          <span class="theHeadLogin">
            <a href="http://120.46.140.235:9011/login?redirect=/index"> 登录</a> </span>
          <!-- <span class="theHeadVerticalBar"></span>
          <span class="theHeadLogin">
            <router-link to="#">注册</router-link>
          </span> -->
        </div>

        <div class="header_right" v-if="userName">
          <span class="loginAvatar">
            <img src="../assets/image/loginico.png" alt="" />
          </span>
          <span class="theHeadLogin">
            <span class="loginName">
              <router-link to="/teachersPersonalCenter">{{
                  userName
              }}</router-link>
            </span>
            <span class="loginOut" @click="loggedOut()">退出</span>
          </span>
        </div>
      </div>
    </div>

    <div class="theFirstNavigation">
      <div class="theHeadWidth">
        <ul class="levelOfClassificationOfUl">

          <li class="navigationLevelClassification" v-if="selectTheNumberOfs == -1 && secondaryToChangeColor == -1"
            @click="returnToTheHomePage(selectTheNumberOfs = -1)">

            <span class="homePageStyle">首页</span>
          </li>
          <li class="navigationLevelClassification" @click="returnToTheHomePage(selectTheNumberOfs = -1)" v-else>
            首页
          </li>


          <li class="navigationLevelClassification" v-for="(item, index) in theNavigationDataAcquisition" :key="index"
            @mouseenter="columnClick(item.deptId, index)" @mouseleave="removeTheStyle()">



            <span class="aaaa"
              :class="{ trainingCenterStyle: whetherToClickOnTheLower && selectTheNumberOf == index || secondaryToChangeColor == index }">{{
                  item.deptName
              }}

              <span class="nabla" v-if="whetherToClickOnTheLower && selectTheNumberOf == index">
                <img src="../assets/image/daosanjiao.png" alt="">
              </span>
              <span class="theTriangle" v-else>
                <img src="../assets/image/sanjiao.png" alt="">
              </span>
            </span>
            <div class="secondaryNavigationDropdown" v-show="whetherToClickOnTheLower && selectTheNumberOf == index">
              <ul class="theSecondaryClassificationOfUl">
                <li v-for="(items, index) in secondaryNavigationData" :key="index"
                  @click="clickOnTheSecondJump(items.id, items.parentId)">
                  {{ items.deptName }}
                </li>



              </ul>

            </div>
          </li>
          <li class="navigationLevelClassification"  @mouseenter="columnClick('', 5)" @mouseleave="removeTheStyle()">
            <a href="http://120.46.140.235:9014">
            <span class="aaaa"  :class="{ trainingCenterStyle:selectTheNumberOfs == 5 }">

             实训大数据中心
            </span>
          </a>


          </li>
        </ul>
      </div>
    </div>
  </div>
  <!--头部结束-->
</template>

<script>
import router from "@/router";
import { ref, reactive, watch } from "vue";
import {
  homePageNavigation,
} from "../assets/api/index";

export default {

  setup() {

    //首页导航
    const homePageNavigationRequest = reactive({
      parentId: 0,
    });

    const theNavigationDataAcquisition = ref([]);
    const secondaryNavigationData = ref([]);
    const professionalGroupOfAccess = () => {
      homePageNavigation(homePageNavigationRequest).then((res) => {
        theNavigationDataAcquisition.value = res.data;

      })
    };
    professionalGroupOfAccess();


    //获取二级导航分类
    const obtainTheSecondaryNavigationClassification = () => {
      homePageNavigation(homePageNavigationRequest).then((res) => {
        secondaryNavigationData.value = res.data;

      })
    };




    const whetherToClickOnTheLower = ref(false);
    const secondaryNavigationClassification = ref([]);
    const selectTheNumberOf = ref();
    const selectTheNumberOfs = ref(-1);
    //首页导航点击
    const columnClick = (value, index) => {
      homePageNavigationRequest.parentId = value;

      whetherToClickOnTheLower.value = true;
      selectTheNumberOf.value = index;
      selectTheNumberOfs.value = index;
      obtainTheSecondaryNavigationClassification();



    };
    //移除样式
    const removeTheStyle = () => {
      selectTheNumberOfs.value = -1;

      secondaryNavigationData.value = [];
      whetherToClickOnTheLower.value = false;
    };

    //返回首页
    const secondaryToChangeColor = ref([localStorage.getItem("parentId")]);
    const returnToTheHomePage = () => {
      router.push('/liaoningTraffic')
      localStorage.setItem("parentId", -1);

      secondaryToChangeColor.value = -1;

    };


    //二级跳转

    const clickOnTheSecondJump = (id, parentId) => {



      localStorage.setItem("parentId", parentId - 1);
      id = id - 6;
      router.push({ path: 'theListOf', query: { roadId: id } })
      secondaryToChangeColor.value = parentId - 1;


      // setTimeout(function () {
      //   location.reload();
      // }, 10);
    };

    return {
      //首页导航
      secondaryToChangeColor,
      clickOnTheSecondJump,
      professionalGroupOfAccess,
      theNavigationDataAcquisition,
      homePageNavigationRequest,
      whetherToClickOnTheLower,
      selectTheNumberOf,
      selectTheNumberOfs,
      obtainTheSecondaryNavigationClassification,

      secondaryNavigationData,
      removeTheStyle,
      //首页点击
      columnClick,
      returnToTheHomePage,



    };
  },

  name: "headerTop",
};
</script>

<style scoped>
.header {
  height: 200px;
  background: #fff;
}

.loginOut {
  color: #a50c0d;
  margin-left: 8px;
  cursor: pointer;
}


.homePageStyle {
  width: 100px;
  display: inline-block;
  border-top: 3px solid #6e0013;
  line-height: 43px;
  color: #6e0013;
  font-weight: bold;
}

.theSecondaryClassificationOfUl li {
  background: #ce3032;
  border-bottom: 1px solid #de7475;
  padding: 0 15px 0 15px;
  min-width: 250px;
  text-align: start;
}

.theSecondaryClassificationOfUl li {
  color: #FFF;
}

.theSecondaryClassificationOfUl li:hover {
  background: #a50c0d;
}




.trainingCenterStyle {
  border-top: 2px solid #6e0013;
  display: inline-block;
  background: #a50c0d;
  width: 100%;
  color: #FFF;
  height: 47px;
  line-height: 47px;

}

.secondaryNavigationDropdown {
  position: relative;
  bottom: 3px;
}
</style>